import React, { useEffect, useState } from "react";
import Appqr from '../../components/Appqr';
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link,useNavigate } from "react-router-dom";
import "./CallMeCard.css";
import API from "../../Utils/Api";
import loader from "../../assests/loader.gif";


const CallMeCard = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const [inputs,setInputs] = useState({id:'',header:'',title:'',orignal_price:0,price:0,description:'',sub_description:'',vat:0,shipping_within_ireland:0,international_shipping:0,total_price:0,vat_total:0,grand_total:0,shipping:0,shipping_text:''});

  const [mainImg, setMainImg] = useState(
    process.env.REACT_APP_BASE_URL + 'assests/images/call-1.jpg'
  );

  const [qty, setQty] = useState(1);

  const increaseQty = () => {
  setQty(prevQty => {
    const newQty = prevQty + 1;

    const price = inputs.price;
    const total_price = price * newQty;

    const vat = inputs.vat;
    const vat_total = (total_price * vat) / 100;
    const shipping_within_ireland = inputs.shipping_within_ireland;
    const sub_total = total_price + vat_total;

    var grand_total=sub_total+shipping_within_ireland;
    var grand_total1=parseFloat(grand_total);
    setInputs(prevInputs => ({
      ...prevInputs,
      total_price: total_price,
      vat_total: vat_total,
      grand_total: grand_total1
    }));

    return newQty;
  });
};

  const decreaseQty = () => {
  setQty(prevQty => {
    const newQty = prevQty > 1 ? prevQty - 1 : 1;

    const price = inputs.price;
    const total_price = price * newQty;

    const vat = inputs.vat;
    const vat_total = (total_price * vat) / 100;

    const shipping_within_ireland = inputs.shipping_within_ireland;
    const sub_total = total_price + vat_total;

    var grand_total=sub_total+shipping_within_ireland;
    var grand_total1=parseFloat(grand_total);
    setInputs(prevInputs => ({
      ...prevInputs,
      total_price: total_price,
      vat_total: vat_total,
      grand_total: grand_total1
    }));

    return newQty;
  });
};

  useEffect(() => {
    document.title = `Call Me Cards | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'callme';

    /* Start get product */
    API.post("get_product_detail")
      .then((response) => {
        setLoading(false);
        if (response.data.status === false) {

        } else {

            var total_price=parseFloat(response.data.data.orignal_price);  
            var vat=parseFloat(response.data.data.vat);
            var vat_total=total_price*vat/100;
            var shipping_within_ireland=parseFloat(response.data.data.shipping_within_ireland);
            var grand_total1=vat_total+shipping_within_ireland;
            var grand_total=total_price+parseFloat(grand_total1);
            var grand_total2=parseFloat(grand_total);

            
           setInputs({
            id:response.data.data.id,
            header:response.data.data.header,
            title:response.data.data.title,
            orignal_price:response.data.data.price,
            price:response.data.data.orignal_price,
            description:response.data.data.description,
            sub_description:response.data.data.sub_description,
            vat:vat,
            shipping_within_ireland:shipping_within_ireland,
            international_shipping:response.data.data.international_shipping,
            total_price:total_price,
            vat_total:vat_total,
            grand_total:grand_total2,
            shipping:shipping_within_ireland,
            shipping_text:'Shipping within Ireland'
          });
        }
      })
      .catch((error) => {
        setLoading(false);
      });
    /* End get product */

  }, []);

const check_out = () => {
  navigate("/check-out-call", { state: { inputs,qty } });
}

  return (
    <>
      <Header />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={process.env.REACT_APP_BASE_URL + 'assests/images/callme-new.png'}
          alt=""
          className="img-fluid"
        />
      </div>

      <div className="container-fluid owned new und">
        <div className="get-miss pt-0">
          <div className="row d-flex align-items-strech g-4">
            {/* Image Section */}
            <div className="col-lg-6">
              <div className="mb-4">
                <img
                  src={mainImg}
                  alt="Event Promo"
                  className="img-fluid main-img"
                />
              </div>

              <div className="row g-2 g-sm-3">
                <div className="col-sm-4 col-4">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/call-2.jpg'}
                    alt="Event Promo"
                    className="img-fluid thumb-img"
                    onClick={() =>
                      setMainImg(process.env.REACT_APP_BASE_URL + 'assests/images/call-2.jpg')
                    }
                  />
                </div>
                <div className="col-sm-4 col-4">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/call-3.jpg'}
                    alt="Event Promo"
                    className="img-fluid thumb-img"
                    onClick={() =>
                      setMainImg(process.env.REACT_APP_BASE_URL + 'assests/images/call-3.jpg')
                    }
                  />
                </div>
                <div className="col-sm-4 col-4">
                  <img
                    src={process.env.REACT_APP_BASE_URL + 'assests/images/call-4.jpg'}
                    alt="Event Promo"
                    className="img-fluid thumb-img"
                    onClick={() =>
                      setMainImg(process.env.REACT_APP_BASE_URL + 'assests/images/call-4.jpg')
                    }
                  />
                </div>
              </div>
            </div>

            {/* Text Section */}
            <div className="col-lg-6 d-flex">
              <div className="get-app d-flex flex-column flex-grow-1 horiz">
                <div className="tired">
                  <h2>{inputs.header}</h2>
                  <h4 className="mb-0">{inputs.title}</h4>
                  <div className="pricy mb-3">€{inputs.orignal_price}</div>
                </div>
                <div className="tired-2 mt-auto">
                  <p className="text-start linung pb-3 mb-3">
                    {inputs.description}
                  </p>
                  <p className="text-start mb-3">
                    {inputs.sub_description}
                  </p>

                  <div className="d-flex gap-3 mb-4">
                    <div className="boxa">
                      INCLUDES SHIPPING WITHIN IRELAND
                    </div>
                    <div className="boxa">
                      PERFECT GIFT FOR
                      A SINGLE FRIEND
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-3 mb-4 item-box">
                    <span>QTY </span>

                    <button className="qty-btn" onClick={decreaseQty}>−</button>
                    <span>{qty}</span>
                    <button className="qty-btn" onClick={increaseQty}>+</button>
                  </div>

                  <div className="arrive-new mt-4" onClick={() => check_out()}>
                    <Link  className="btn bros-bu text-decoration-none" >
                      ADD TO CART  
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Appqr />
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
      <Footer />
    </>
  );
};

export default CallMeCard;
